"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = onNextTick;
var timeout = void 0;
var timeoutQueue = [];

function onNextTick(cb) {
  timeoutQueue.push(cb);

  if (!timeout) {
    timeout = setTimeout(function () {
      timeout = null;

      // Drain the timeoutQueue
      var item = void 0;
      // eslint-disable-next-line no-cond-assign
      while (item = timeoutQueue.shift()) {
        item();
      }
    }, 0);
  }

  var isSubscribed = true;

  return function unsubscribe() {
    if (!isSubscribed) {
      return;
    }

    isSubscribed = false;

    var index = timeoutQueue.indexOf(cb);
    if (index === -1) {
      return;
    }

    timeoutQueue.splice(index, 1);

    if (!timeoutQueue.length && timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/react-waypoint/build/onNextTick.js
// module id = ./node_modules/react-waypoint/build/onNextTick.js
// module chunks = 168707334958949